import fetch from "@src/common/lib/axios";
const API = {
    //按人员类型统计
    statPersonnelByPersonnelMark: "/dep/comprehensiveSituation/statPersonnelByPersonnelMark.json",
    //人员统计
    statPersonnelTrafficByHours: '/dep/comprehensiveSituation/statPersonnelTrafficByHours.json',
    //在园
    statPersonnelInParkByHours: '/dep/comprehensiveSituation/statPersonnelInParkByHours.json',
    //车辆概览信息
    queryParkingControl: '/bas/queryParkingControl/queryParkingControl',
    //当前车辆时长统计
    queryVehicleTimeLong: '/dep/queryVehicleTotal/queryVehicleTimeLong',
    //前一日车辆进出吞吐量统计数据
    queryVehicleThroughputCapacity: '/dep/queryVehicleTotal/queryVehicleThroughputCapacity',
    // 前一日在园车辆趋势
    queryVehicleTrend: '/dep/queryVehicleTotal/queryVehicleTrend',
    //当前车辆停车时长统计
    //冷库使用情况
    statColdStorageUse: '/dep/comprehensiveSituation/statColdStorageUse.json',
    //温度态势
    statAvgTemperatureAndhumidity: '/dep/comprehensiveSituation/statAvgTemperatureAndhumidity.json',
    // 统计告警
    // /dep/comprehensiveSituation/statAlarmAllTotal.json
    statAlarmAllTotal: '/dep/comprehensiveSituation/statAlarmAllTotal.json',
    //     统计人员
    // /dep/comprehensiveSituation/statPersonnelAllInPark.json
    statPersonnelAllInPark: '/dep/comprehensiveSituation/statPersonnelAllInPark.json',
    ///carbon/per/year/statistics/list.json
    // 查询每年年度电量碳排放
    carbonListByYear: '/bms/carbon/per/year/statistics/list.json',
    ///carbon/day/statistics/build/list.json
    // 按楼栋统计碳排放
    carbonByBuild: '/bms/carbon/day/statistics/build/list.json',
    ///carbon/per/energy/meter/statistics/list.json
    // 查询当天当月当日电表碳排放
    carbonByDay: '/bms/carbon/per/energy/meter/statistics/list.json',
    // 分页查询按月统计碳排放量列表
    carbonByMonth: '/bms/carbon/monthly/statistics/page.json',
    //     /carbon/per/day/statistics/list.json
    // 查询近几天碳排放占比
    carbonByLastDays: '/bms/carbon/per/day/statistics/list.json',
    //查询天气
    queryBacnetStatusList: '/bas/firefightoperation/queryBacnetStatusList.json',

    checkMenuPath: '/cms/account/selectMenuPath.json',

    dispatch: {
        queryGoods: '/dep/queryRailwayPlatformVehicle/queryGoods',
        queryVehicleLineUp: '/dep/queryRailwayPlatformVehicle/queryVehicleLineUp',
        queryWaitingLoadedAndUnloaded: '/dep/queryRailwayPlatformVehicle/queryWaitingLoadedAndUnloaded',
        queryPlatformLoadedAndUnloaded: '/dep/queryRailwayPlatformVehicle/queryPlatformLoadedAndUnloaded',
    },
    platform: {
        queryPlatformOccupancyRatioTotal: '/dep/queryRailwayPlatformVehicle/queryPlatformOccupancyRatioTotal',
        queryAppointmentVehicleTotal: '/dep/queryRailwayPlatformVehicle/queryAppointmentVehicleTotal',
        queryAppointmentWork: '/dep/queryRailwayPlatformVehicle/queryAppointmentWork',
        queryWorkProductiveness: '/dep/queryRailwayPlatformVehicle/queryWorkProductiveness',
        queryVehicleTimeLong: '/dep/queryVehicleTotal/queryVehicleTimeLong',
        vehicleParkingTime: '/dep/queryRailwayPlatformVehicle/dispatchingVehicleParkingTime',
    },
    security: {
        statAlarmTotal: '/dep/comprehensiveSituation/statAlarmTotal.json',
        statAlarmByAlarmLevel: '/dep/comprehensiveSituation/statAlarmByAlarmLevel.json',
        statAlarmWorkOrder: '/dep/comprehensiveSituation/statAlarmWorkOrder.json',
        statAlarmByAlarmType: '/dep/comprehensiveSituation/statAlarmByAlarmType.json',
        statisticsAlarmTotal: '/dep/comprehensiveSituation/statisticsAlarmTotal.json' // 告警数据统计
    },
    emergency: {
        statEmergencyByType: '/dep/comprehensiveSituation/statEmergencyByType.json',
        statEmergencyByMonth: '/dep/comprehensiveSituation/statEmergencyByMonth.json',
        statEmergencyByStatus: '/dep/comprehensiveSituation/statEmergencyByStatus.json',
        statEmergencyTotal: '/dep/comprehensiveSituation/statEmergencyTotal.json',
    },
    energy: {
        //上个月的用电量
        queryEnergyRecordByLastMonth: '/dep/queryEnergy/queryEnergyRecordByLastMonth',
        queryWaterRecordByLastMonth: '/dep/queryEnergy/queryWaterRecordByLastMonth',
        //当日用电量
        queryEnergyRecordByDay: '/dep/queryEnergy/queryEnergyRecordByDay',
        //当月用电量
        queryEnergyRecordByMonth: '/dep/queryEnergy/queryEnergyRecordByMonth',
        //前六个月用电量
        queryEnergyRecordBySixMonth: '/dep/queryEnergy/queryEnergyRecordBySixMonth',
        //前六月用水量
        queryWaterRecord: '/dep/queryEnergy/queryWaterRecord',
        //不同库区能耗
        queryEnergyRecordByArea: '/dep/queryEnergy/queryEnergyRecordByArea'
    }
    ///dep/queryEnergy/queryWaterRecordByLastMonth

};

export default API;